import Vue from 'vue';
import VueRouter from 'vue-router';

import routerHistory from './router-history';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Expected',
    component: () => import('@/views/Expected.vue'),
  },
  {
    path: '/present',
    name: 'Present',
    component: () => import('@/views/Present.vue'),
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/User.vue'),
  },
  {
    path: '/edit',
    name: 'Editor',
    component: () => import('@/views/Editor.vue'),
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/NotFound.vue'),
  },
];

import basePath from '../lib/base-path';
const router = new VueRouter({
  base: basePath,
  mode: basePath == './' ? 'hash' : 'history',
  routes,
  scrollBehavior: routerHistory.scrollBehavior,
});

export default router;
